export const ADD_LIST_CHEF = 'ADD_LIST_CHEF';
export const ADD_CHEF = 'ADD_CHEF';
export const UPDATE_CHEF = 'UPDATE_CHEF';
export const DELETE_CHEF = 'DELETE_CHEF';